import { useState, useEffect } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquareCaretLeft } from "@fortawesome/free-solid-svg-icons";

const AddTiposRelacion = () => {
    const [Nombre, setNombre] = useState("");
    const [inversaNombre, setInversaNombre] = useState("");
    const [mensaje, setMensaje] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        // Aquí puedes cargar datos adicionales si es necesario.
    }, []);

    const createTipoRelacion = async (e) => {
        e.preventDefault();
        try {
            await api.post(`/createTipoRelacion`, {
                Nombre,
                inversa_nombre: inversaNombre
            });
            setNombre("");
            setInversaNombre("");
            setMensaje("Tipo de relación creado con éxito.");
        } catch (error) {
            console.log(error);
            setMensaje("Error al crear el tipo de relación.");
        }
    };
    

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="columns mt-5 is-centered">
            <div className="column is-half">
                <label className="label">Agregar Tipo de Relación</label>
                <br />
                {mensaje && <div className="notification is-primary">{mensaje}</div>}
                <form onSubmit={createTipoRelacion}>
                    <div className="field">
                        <label className="label required">Nombre</label>
                        <div className="control">
                            <input
                                type="text"
                                className="input"
                                value={Nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                placeholder="Nombre"
                                required
                            />
                        </div>
                    </div>
                    <div className="field">
                        <label className="label">Nombre Inverso</label>
                        <div className="control">
                            <input
                                type="text"
                                className="input"
                                value={inversaNombre}
                                onChange={(e) => setInversaNombre(e.target.value)}
                                placeholder="Nombre inverso (opcional)"
                            />
                        </div>
                    </div>
                    <div className="level">
                        <div className="level-left">
                            <FontAwesomeIcon icon={faSquareCaretLeft} size="2xl" style={{ color: "#3488CE", cursor: "pointer" }} onClick={handleGoBack} />
                        </div>
                        <div className="field level-right">
                            <button type="submit" className="level-item" style={{ border: "none", backgroundColor: "#00ff11", color: "white" }}>
                                Guardar <FontAwesomeIcon icon={faCheck} size="2xl" style={{ color: "white" }} />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTiposRelacion;
